export default __webpack_public_path__ + "static/media/1.99a14a57.jpg";